import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TopicSwapStepNames, TopicSwapInputNames, TPortfolio } from '@dekafvv/sharedfrontend';
import type {
    TAllocation,
    TExAnteTopicSwap, TInitialTopicSwapValues, TNewPseudoIsin, TPositionIsins, TSecurities, TTopicSwap,
} from './types';

export const initialTopicSwapValues = {
    [TopicSwapStepNames.selectionSwap]: {
        [TopicSwapInputNames.selectionSwap]: '',
    },
    [TopicSwapStepNames.swapTopics]: {
        [TopicSwapInputNames.topicsComfort]: [],
        [TopicSwapInputNames.topicsIndividual]: [],
        [TopicSwapInputNames.portfolioTypeRadio]: '',
    },
    [TopicSwapStepNames.overview]: {
        [TopicSwapInputNames.overviewCheckBox]: false,
    },
    [TopicSwapStepNames.mtan]: {
        [TopicSwapInputNames.mtan]: '',
    },
};

export const initialTopicSwapState: TTopicSwap = {
    answers: initialTopicSwapValues,
    initialSwapValues: initialTopicSwapValues,
    exAnteTopicSwap: {
        exAnteCostId: '',
        zeroCostStatement: false,
        exAnteCostStatement: '',
    },
    securities: {
        securitiesComfort: [],
        securitiesIndividual: [],
    },
    portfolio: undefined,
    positionIsins: [],
    newPseudoIsin: '',
    newAllocations: [],
};

const reducers = {
    setTopicSwapAnswers: (state, action: PayloadAction<Partial<TInitialTopicSwapValues>>) => ({
        ...state,
        answers: {
            ...state.answers,
            ...action.payload,
        },
    }),
    setExAnteTopicSwap: (state, action: PayloadAction<TExAnteTopicSwap>) => ({
        ...state,
        exAnteTopicSwap: action.payload,
    }),
    setSecurities: (state, action: PayloadAction<TSecurities>) => ({
        ...state,
        securities: action.payload,
    }),
    setTopicSwapPortfolio: (state, action: PayloadAction<TPortfolio>) => ({
        ...state,
        portfolio: action.payload,
    }),
    setPositionIsins: (state, action: PayloadAction<TPositionIsins>) => ({
        ...state,
        positionIsins: action.payload,
    }),
    setInitialSwapValues: (state, action: PayloadAction<TInitialTopicSwapValues>) => ({
        ...state,
        initialSwapValues: action.payload,
    }),
    setDefaultTopicSwap: (state) => ({
        ...state,
        ...initialTopicSwapState,
    }),
    setNewPseudoIsin: (state, action: PayloadAction<TNewPseudoIsin>) => ({
        ...state,
        newPseudoIsin: action.payload,
    }),
    setNewAllocations: (state, action: PayloadAction<TAllocation>) => ({
        ...state,
        newAllocations: action.payload,
    }),
};

const topicSwapSlice = createSlice({
    name: 'topicSwapSlice',
    initialState: initialTopicSwapState,
    reducers,
});

export default topicSwapSlice;
